// Silenciar mensajes de consola (log, warn, error, etc.)
const noop = () => {}
if (typeof console !== 'undefined') {
  console.log = noop
  console.warn = noop
  console.error = noop
  console.info = noop
  console.debug = noop
}

import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { LanguageProvider } from './i18n/LanguageContext'
import App from './App'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <LanguageProvider>
        <App />
      </LanguageProvider>
    </BrowserRouter>
  </React.StrictMode>,
)
